<template>
  <div>
    <apexchart
      v-if="sortedEntries.length"
      type="bar"
      :height="Math.max(300, sortedEntries.length * 44 + 80)"
      :options="opts"
      :series="series"
    />
    <empty-state v-else icon="mdi-account-check-outline" :title="$t('no_data')" />
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import EmptyState from "@/components/global/EmptyState.vue";
import { TAKEN_COLORS, CHART_FONT, GRID_COLOR, takenOptions } from "@/components/statistics-report/statsTheme";

export default {
  name: "MoreRestaurantsTakenChart",
  components: { apexchart: VueApexCharts, EmptyState },
  props: {
    orders: { type: Array, default: () => [] },
  },
  computed: {
    sortedEntries() {
      return this.orders
        .map((c) => ({
          name: this.toLatin(c.name),
          taken: c.totals.totalPayed || 0,
          notTaken: (c.totals.total || 0) - (c.totals.totalPayed || 0),
        }))
        .filter((e) => e.taken + e.notTaken > 0)
        .sort((a, b) => b.taken + b.notTaken - (a.taken + a.notTaken));
    },
    categories() {
      return this.sortedEntries.map((e) => e.name);
    },
    series() {
      return [
        { name: this.$t("taken1"), data: this.sortedEntries.map((e) => e.taken) },
        {
          name: this.$t("ordered_not_taken"),
          data: this.sortedEntries.map((e) => e.notTaken),
        },
      ];
    },
    opts() {
      return {
        chart: {
          type: "bar",
          stacked: true,
          toolbar: {
            show: true,
            tools: {
              download: true,
              selection: false,
              zoom: false,
              zoomin: false,
              zoomout: false,
              pan: false,
              reset: false,
            },
          },
          fontFamily: CHART_FONT,
        },
        plotOptions: { bar: { horizontal: true, borderRadius: 3, barHeight: "65%" } },
        colors: TAKEN_COLORS,
        xaxis: { categories: this.categories, labels: { style: { fontSize: "12px" } } },
        yaxis: { labels: { style: { fontSize: "12px" }, maxWidth: 240 } },
        legend: { position: "bottom", horizontalAlign: "center" },
        ...takenOptions(this.sortedEntries),
        fill: { opacity: 1 },
        grid: { borderColor: GRID_COLOR },
        responsive: [
          {
            breakpoint: 600,
            options: {
              yaxis: { labels: { style: { fontSize: "11px" }, maxWidth: 130 } },
              xaxis: { labels: { style: { fontSize: "11px" } } },
              legend: { fontSize: "12px", itemMargin: { horizontal: 6 } },
              plotOptions: { bar: { barHeight: "55%" } },
            },
          },
        ],
      };
    },
  },
};
</script>
